import { apiClient } from "../../../Utilities/apiClient";
import { Review } from "../../../Resources/Data/Reviews";

export interface ReviewsResponse {
  reviews: Review[];
}

export const reviewService = {
  getTrailReviews: (trailId: string | number) =>
    apiClient.get(`/trails/review/list/${trailId}`),

  acceptReview: (reviewId: number) =>
    apiClient.put('/trails/review/accept', { reviewId }),

  rejectReview: (reviewId: number) =>
    apiClient.put('/trails/review/reject', { reviewId }),

  getPendingReviews: () =>
    apiClient.get('/trails/review/pending'),

  recalculateTrailRating: (trailId: string | number) =>
    apiClient.post(`/trails/review/recalculate-rating/${trailId}`),
};